import { Link } from 'react-router-dom';
import type { CommitteeMember } from '../types/api.types';
import type { MemberLookupFn } from '../utils/committee';
import { buildCommitteeMembers } from '../utils/committee';

interface CurrentCommitteeProps {
  committeeMembers: CommitteeMember[];
  memberLookup: MemberLookupFn;
}

interface CommitteeMemberDisplay {
  id: string;
  role: string;
  name: string;
}

// Component for a single committee member card
const CommitteeMemberCard = ({ member }: { member: CommitteeMemberDisplay }) => (
  <div
    key={`${member.id}-${member.role}`}
    style={{
      textAlign: 'center',
      maxWidth: '150px',
    }}
  >
    <img
      src={`/assets/${member.id}.jpg`}
      alt={member.name}
      style={{
        width: '120px',
        height: '120px',
        objectFit: 'cover',
        borderRadius: '8px',
        marginBottom: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    />
    <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '6px' }}>
      <Link to={`/members/${member.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        {member.name}
      </Link>
    </div>
    <div style={{ fontSize: '14px', color: '#666', fontStyle: 'italic' }}>{member.role}</div>
  </div>
);

export default function CurrentCommittee({ committeeMembers, memberLookup }: CurrentCommitteeProps) {
  // Get the last set of values from the list (most recent season's committee)
  const latestCommittee = committeeMembers.length > 0 ? committeeMembers[committeeMembers.length - 1] : null;

  if (!latestCommittee) {
    return (
      <div className="aboutpage">
        <p>No committee information available.</p>
      </div>
    );
  }

  // Build list of committee members with their roles
  const members = buildCommitteeMembers(latestCommittee, memberLookup);

  return (
    <div className="aboutpage">
      <p>
        The Crazy English Golf Society is run by a committee of volunteers who organize events, manage finances, and
        ensure the smooth running of the society.
      </p>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '30px',
          justifyContent: 'center',
          alignItems: 'flex-start',
          marginTop: '30px',
        }}
      >
        {members.map((member) => (
          <CommitteeMemberCard key={`${member.id}-${member.role}`} member={member} />
        ))}
      </div>
    </div>
  );
}
